import * as shared from 'pericles-shared'
import * as types from 'pericles-types'

export const getQuestions = shared.callFunction<
  types.GetQuestionsInput,
  types.GetQuestionsResponse
>('getQuestions')
